import { useParams } from "react-router-dom";

import BroadcastPlayer from "@/components/player/BroadcastPlayer";

import { useGetBroadcastDetail } from "@/hooks/api/broadcast.hooks";

const LivePlayer = () => {
  const { id } = useParams() as { id: string };

  const { data } = useGetBroadcastDetail(+id);

  return (
    <div className="relative h-full w-full">
      <BroadcastPlayer data={data} />
    </div>
  );
};

export default LivePlayer;
